import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { USER_LOGIN_URL } from '../constats/urls';

const USER_KEY = 'User';
const WEB_ACCESS_DISABLED_MESSAGE = 'El acceso web no está habilitado para este tanque.';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url === USER_LOGIN_URL) {
      return next.handle(request);
    }

    const userJson = localStorage.getItem(USER_KEY);
    if (!userJson) {
      return next.handle(request);
    }

    let token: string = null;
    try {
      const user = JSON.parse(userJson);
      token = user && user.token ? user.token : null;
    } catch (e) {
      return next.handle(request);
    }

    if (!token) {
      return next.handle(request);
    }

    const authRequest = request.clone({
      setHeaders: { Authorization: 'Bearer ' + token },
    });

    return next.handle(authRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        const message = error.error && error.error.message ? error.error.message : '';
        if (error.status === 403 && message === WEB_ACCESS_DISABLED_MESSAGE) {
          this.router.navigate(['/web-access-disabled']);
        }
        return throwError(error);
      })
    );
  }
}
